import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./translations/locales/en/translation.json";
import translationES from "./translations/locales/es/translation.json";
import translationFR from "./translations/locales/fr/translation.json";
import translationIT from "./translations/locales/it/translation.json";
import translationPT from "./translations/locales/pt/translation.json";
import translationAR from "./translations/locales/ar/translation.json";
import translationPL from "./translations/locales/pl/translation.json";
import translationRU from "./translations/locales/ru/translation.json";
import translationDE from "./translations/locales/de/translation.json";
import translationVI from "./translations/locales/vi/translation.json";
import translationZH from "./translations/locales/zh/translation.json";
import translationPH from "./translations/locales/ph/translation.json";
import translationTL from "./translations/locales/tl/translation.json";
import translationJA from "./translations/locales/ja/translation.json";
import translationNL from "./translations/locales/nl/translation.json";
import translationHI from "./translations/locales/hi/translation.json";
import translationTR from "./translations/locales/tr/translation.json";

export const availableLanguages = [
  "en",
  "es",
  "fr",
  "pt",
  "ar",
  "it",
  "pl",
  "ru",
  "de",
  "vi",
  "zh",
  "ph",
  "ja",
  "nl",
  "hi",
  "tr",
  "tl",
];

// Match whole path segments, not substrings: a plain `includes("/tr")` also
// matches routes like /app/track-song and would switch the app to Turkish.
const pathSegments = window.location.pathname.split("/").filter(Boolean);

let lang = "en";
for (const code of availableLanguages.filter((c) => c !== "en")) {
  if (pathSegments.includes(code)) {
    localStorage.setItem("i18nextLng", code);
    lang = code;
    break;
  }
}
if (lang === "en") {
  localStorage.setItem("i18nextLng", "en");
}

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  fr: { translation: translationFR },
  it: { translation: translationIT },
  pt: { translation: translationPT },
  ar: { translation: translationAR },
  pl: { translation: translationPL },
  ru: { translation: translationRU },
  de: { translation: translationDE },
  vi: { translation: translationVI },
  zh: { translation: translationZH },
  ph: { translation: translationPH },
  tl: { translation: translationTL },
  ja: { translation: translationJA },
  nl: { translation: translationNL },
  hi: { translation: translationHI },
  tr: { translation: translationTR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: lang,
    supportedLngs: availableLanguages,
    debug: false,
    interpolation: { escapeValue: false },
  });

export default i18n;
